<div class="cb-global-form-controls-host" *cbGlobalTemplateHost="'cb-form-controls'+((formKey())? '-'+formKey() : '')">
</div>